import produce from 'immer'

const initialState = {
    vehicles: []
}

const reducer = produce((draft, action) => {
    switch (action.type) {
        case 'NEARBY_VEHICLES_SUCCESS':
            draft.vehicles = action.response.content
            break
        default:
            break
    }
}, initialState)

export default reducer

const deRoot = (state) => state.map
export const selectVehicles = (state) => deRoot(state).vehicles